import request from '@/utils/request'

// 查询列表
export function apiScpMrpHorizontalSummaryRawMaterialList (data) {
  return request({
    url: '/scp/scpMrpHorizontalSummary/rawMaterialList',
    method: 'post',
    data: data
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansCallMaterialPlanExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/callMaterialPlanExecutionTime',
    method: 'get',
    params: query
  })
}

// 动态表头
export function apiScpMrpHorizontalDatesDateDisplayList (query) {
  return request({
    url: '/scp/scpMrpHorizontalDates/dateDisplayList',
    method: 'get',
    params: query
  })
}

// 筛选方案列表
export function apiScpScreeningSchemeSearchAllScheme (query) {
  return request({
    url: '/scp/scpScreeningScheme/searchAllScheme',
    method: 'get',
    params: query
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}
